export const ZINDEX: Record<string, number> = {
  tooltip: 100,
  portal: 9999,
} as const
